import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import theme from "./theme";
import Navigation from "@arelia-components/navigation";
import AppRoutes from "./routes";
import AppContext from "./AppContext";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from "@mui/x-date-pickers";
import { useConnections } from "./api/connections";
import { useAccount } from "./api/account";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { QueryClient, QueryClientProvider } from "react-query";

function App() {
  const { pathname } = useLocation();

  const [selectedArtist, setSelectedArtist] = useState<string | null>(null);
  const [selectHqIsActive, setHqIsActive] = useState<boolean>(false);
  const noMenuRoutes = ["/empty-page", "/stay-connected"];
  const anonymousRoutes = ["/stay-connected"];

  const { data: accountData, refetch } = useAccount({
    placeholderData: { fullName: "loading..." },
    enabled: !anonymousRoutes.some(route => window.location.pathname.includes(route))
  });
  const { data: connectionsData } = useConnections({
    enabled: !anonymousRoutes.some(route => window.location.pathname.includes(route))
  });

  useEffect(() => {
    const hqMode = pathname.startsWith("/hq/");
    setHqIsActive(hqMode);
  }, [pathname]);

  const handleError = async (error: any) => {
    switch (error.status) {
      case 400: {
        toast.error(await error.text());
        break;
      }
      case 401: {
        toast.error("Unauthorized");
        break;
      }
      case 403: {
        toast.error("Not enough permission");
        break;
      }
      case 404: {
        toast.error(await error.text());
        break;
      }
      default: {
        toast.error("Network error");
      }
    }
  }

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        onError: async (error) => {
          await handleError(error);
        }
      },
      mutations: {
        onError: async (error, variable, context) => {
          await handleError(error);
        },
      }
    }
  })

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <AppContext.Provider value={{
            connections: connectionsData as any,
            account: accountData as any,
            selectedArtist: selectedArtist,
            reloadAccount: refetch,
            setSelectedArtist: x => setSelectedArtist(x),
            selectHqIsActive: selectHqIsActive,
            setHqIsActive: x => setHqIsActive(x)
          }}>
            <Box display="flex" width="100vw" height="100vh">
              {noMenuRoutes.some(route => window.location.pathname.includes(route)) ?
                <AppRoutes /> :
                <>
                  <Navigation />
                  <AppRoutes />
                </>
              }
            </Box>
            <CssBaseline />
            <Toaster richColors closeButton />
          </AppContext.Provider>
        </QueryClientProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;